

























import { Component, Vue, Prop } from "vue-property-decorator";
import { FormFieldProps, FormFieldRules, IFormField } from "../../Models/Components.model";
import ButtonList from "../Common/Buttons/ButtonList.vue";
import { UserModel } from "../../Generated/ParticaAPI";
import { ParticaEvent } from "../../Models/ParticaEvent";
import { ButtonConfig } from "../../Models/Buttons";

@Component(
	{
		name: "ResetPasswordForm",
		components: { ButtonList }
	})
export default class ResetPasswordForm extends Vue {
	@Prop() private model: UserModel;
	@Prop() private buttons: ButtonConfig[];
	private validform: boolean = false;
	private formstate: any = {};

	private get formvalid() {
		return this.validform;
	}

	private passwordconfig =
		{
			props: { name: "password", placeholder: "Enter password", label: "Password", } as FormFieldProps,
			rules: { required: true, max: 100, min: 6, } as FormFieldRules
		} as IFormField;

	private confirmPasswordconfig =
		{
			props: { name: "Password", placeholder: "Enter your password again", label: "Confirm Password", } as FormFieldProps,
			rules: { required: true, confirmed: "password" } as FormFieldRules
		} as IFormField;

	// handle button clicks
	private async buttonClicked(clicked: ParticaEvent) {			{
			if (await this.validate()) {
				clicked.item = this.model;
				this.$emit("partica-event", clicked);
			}
		}
	}

	private async validate(): Promise<boolean> {
		{
			let result: boolean = true;
			await this.$validator.validateAll().then(valid => result = valid);
			return result;
		}
	}
}
